import cache from './storage'

const HK_USER_INFO_KEY = '__HK_USER_INFO_KEY__' // 用户信息
const HK_SHOPPING_CAR = '__HK_SHOPPING_CAR__' // 购物车
const HK_SEARCH_TEXT = '__HK_SEARCH_TEXT__' // 搜索词
/**
 * @param {any} userInfo
 */
export const setUserInfoAsync = userInfo => cache.set(HK_USER_INFO_KEY, userInfo)

/**
 * @param {*} def // 默认值，如果没有,则返回默认值
 */
export const getUserInfo = def => cache.get(HK_USER_INFO_KEY, def)

export const hasLogin = () => cache.has(HK_USER_INFO_KEY)

export const clearUserInfoAsync = () => cache.remove(HK_USER_INFO_KEY)

export const setShoppingCar = car => cache.set(HK_SHOPPING_CAR, car)

export const getShoppingCar = def => cache.get(HK_SHOPPING_CAR, def)

export const clearShoppingCar = () => cache.remove(HK_SHOPPING_CAR)

export const setSearchText = text => cache.set(HK_SEARCH_TEXT, text)

export const getSearchText = def => cache.get(HK_SEARCH_TEXT, def)

export const clearSearchText = () => cache.remove(HK_SEARCH_TEXT)



// WEBPACK FOOTER //
// ./src/common/js/store.js